import React, { useEffect, useState } from "react";
import "./cookie-banner.css";

const CookieConsent = ({ onAccept }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = getCookie("cookie_consent");
    if (!consent) {
      setShowBanner(true);
    } else if (consent === "accepted" && onAccept) {
      onAccept();
    }
  }, [onAccept]);

  const acceptCookies = () => {
    setCookie("cookie_consent", "accepted", 365);
    setShowBanner(false);
  };

  const declineCookies = () => {
    setCookie("cookie_consent", "declined", 365);
    setShowBanner(false);
  };

  const setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 86400 * 1000).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  };

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>
          This website uses technically necessary cookies to save your selection.
        </p>
        <div className="cookie-buttons">
          <button onClick={acceptCookies} className="accept-btn">
            accept
          </button>
          <button onClick={declineCookies} className="decline-btn">
            decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
